import React, { useState } from "react";
import styles from "./OrganisingSession.module.scss";

import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import { messages } from "../Workflow.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";
import { Button } from "@src/lms/jelly/extensions/ui";
import { NewSessionModal } from "./modals/NewSession";
import { TrackGroupsModal } from "./modals/TrackGroups";
import { OrganiseTracksModal } from "./modals/OrganiseTracks";
import { SubmixesModal } from "./modals/Submixes";
import { DolbyBridgeModal } from "./modals/DolbyBridge";

export const OrganisingSession: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  const [isNewSessionModalVisible, setIsNewSessionModalVisible] = useState(false);
  const [isTrackGroupsModalVisible, setIsTrackGroupsModalVisible] = useState(false);
  const [isOrganiseTracksModalVisible, setIsOrganiseTracksModalVisible] = useState(false);
  const [isSubmixesModalVisible, setIsSubmixesModalVisible] = useState(false);
  const [isDolbyBridgeModalVisible, setIsDolbyBridgeModalVisible] = useState(false);
  return (
    <div className={styles.container}>
      {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
      <SpatialCarousel showBreadcrumbs>
        {[
          <div key={1} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.organisingTheSessionTitle)}</h3>
            <ui.Scrollbars>
              <div className={styles.subtitleContainer}>
                <span className={styles.subtitle}>{formatMessage(messages.organisingTheSessionTitle1)}</span>
                <Button
                  className={styles.button}
                  shape="round"
                  size="small"
                  onClick={() => setIsNewSessionModalVisible(true)}
                  icon="cil-file-add"
                >
                  {formatMessage(messages.organisingTheSessionButton1)}
                </Button>
              </div>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.organisingTheSessionDescription1) }}></p>

              <div className={styles.subtitleContainer}>
                <span className={styles.subtitle}>{formatMessage(messages.organisingTheSessionTitle2)}</span>
                <Button
                  className={styles.button}
                  shape="round"
                  size="small"
                  onClick={() => setIsTrackGroupsModalVisible(true)}
                  icon="cil-color-border"
                >
                  {formatMessage(messages.organisingTheSessionButton2)}
                </Button>
              </div>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.organisingTheSessionDescription2) }}></p>

              <div className={styles.subtitleContainer}>
                <span className={styles.subtitle}>{formatMessage(messages.organisingTheSessionTitle3)}</span>
                <Button
                  className={styles.button}
                  shape="round"
                  size="small"
                  onClick={() => setIsOrganiseTracksModalVisible(true)}
                  icon="cil-input-component"
                >
                  {formatMessage(messages.organisingTheSessionButton3)}
                </Button>
              </div>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.organisingTheSessionDescription3) }}></p>
            </ui.Scrollbars>
          </div>,
          <div key={2} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.organisingTheSessionTitle)}</h3>
            <ui.Scrollbars>
              <div className={styles.subtitleContainer}>
                <span className={styles.subtitle}>{formatMessage(messages.organisingTheSessionTitle4)}</span>
                <Button
                  className={styles.button}
                  shape="round"
                  size="small"
                  onClick={() => setIsSubmixesModalVisible(true)}
                  icon="cil-file-add"
                >
                  {formatMessage(messages.organisingTheSessionButton4)}
                </Button>
              </div>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.organisingTheSessionDescription4) }}></p>

              <div className={styles.subtitleContainer}>
                <span className={styles.subtitle}>{formatMessage(messages.organisingTheSessionTitle5)}</span>
                <Button
                  className={styles.button}
                  shape="round"
                  size="small"
                  onClick={() => setIsDolbyBridgeModalVisible(true)}
                  icon="cil-color-border"
                >
                  {formatMessage(messages.organisingTheSessionButton5)}
                </Button>
              </div>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.organisingTheSessionDescription5) }}></p>
            </ui.Scrollbars>
          </div>,
        ]}
      </SpatialCarousel>
      <NewSessionModal visible={isNewSessionModalVisible} onClose={() => setIsNewSessionModalVisible(false)} />
      <TrackGroupsModal visible={isTrackGroupsModalVisible} onClose={() => setIsTrackGroupsModalVisible(false)} />
      <OrganiseTracksModal
        visible={isOrganiseTracksModalVisible}
        onClose={() => setIsOrganiseTracksModalVisible(false)}
      />
      <SubmixesModal visible={isSubmixesModalVisible} onClose={() => setIsSubmixesModalVisible(false)} />
      <DolbyBridgeModal visible={isDolbyBridgeModalVisible} onClose={() => setIsDolbyBridgeModalVisible(false)} />
    </div>
  );
};
